import {
  any, boolean, date, nullable,
  string,
} from '@sda/sdk/helpers/types.bitmasks';

export const PrivateMessageMask = {
  body: any | nullable,
  fileUrl: string | nullable,
  eventType: string,
  threadId: string,
  showId: string | nullable,
  destinationThreadId: string | nullable,
  isAdminMessage: boolean,
  profileId: string | nullable,
  profileSubscribers: any,
  masterThreadId: string,
  destinationBeaconId: string | nullable,
  destinationShowId: string | nullable,

  createdAt: date,
  collaborators: any,
  owner: string,
  updatedAt: date,
  badges: any | nullable,
  pinned: boolean,
  authorCache: any,
};
